import React, { useEffect, useState } from 'react';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import { companyUtil, dateUtil, systemCdUtil } from '../../../../utils/globalUtil.tsx';
import CustomRadio from '../../../Common/customComponents/CustomRadio.tsx';

import SampleMapImage from '/assets/icon/global/sample-map-image.svg';
import CustomSelectSingle from '../../../Common/customComponents/CustomSelectSingle.tsx';
import CustomDatetime from '../../../Common/customComponents/CustomDatetime.tsx';
import CustomNumber from '../../../Common/customComponents/CustomNumber.tsx';
import FormApproval from './approval/FormApproval.tsx';
import CustomTextarea from '../../../Common/customComponents/CustomTextarea.tsx';
import PermitIssueForm from './PermitIssueForm.tsx';
import PermitIssueMap from './PermitIssueMap.tsx';
import CustomUploader from 'containers/Common/customComponents/CustomUploader.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import JhaSearchModal from '../modal/JhaSearchModal.tsx';
import DeviceRegisterModal from '../modal/DeviceRegisterModal.tsx';
import CustomSelectMulti from 'containers/Common/customComponents/CustomSelectMulti.tsx';
import CustomRadioSingle from 'containers/Common/customComponents/CustomRadioSingle.tsx';
import { safObjectHelper } from '../../../../utils/SafObjectHelper.ts';
import { ptwApi } from '../../../../api/ptw.api.ts';
import WorkLocationModal from '../modal/WorkLocationModal.tsx';
import { codeApi } from '../../../../api/code.api.ts';
import DashIcon from '/assets/icon/global/cancel.svg';
import ClockIcon from '/assets/icon/global/extension.svg';
import ActionClock from '/assets/icon/global/action-clock.svg';
import ExtensionHistoryModal from '../modal/ExtensionHistoryModal.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange: any;
  formCode: string;
  isReadOnly: boolean;
  userInfo: any;
  isFinish: boolean;
  tbmNo?: string;
}

const Form03SpaceDetail = (props: IProps) => {
  const [isWorkLocationModalOpen, setIsWorkLocationModalOpen] = useState<boolean>(false);
  const [isJhaSeaerchModalOpen, setJhaSearchModalOpen] = useState<boolean>(false);
  const [isStatementSearchModalOpen, setStatementSearchModalOpen] = useState<boolean>(false);
  const [isSpCmSearchModalOpen, setSpCmSearchModalOpen] = useState<boolean>(false);
  const [gubun, setGubun] = useState<string>('cctv');
  const [isDeviceRegisterModalOpen, setIsDeviceRegisterModalOpen] = useState<boolean>(false);
  /*공통코드*/
  const [disciplineCdList, setDisciplineCdList] = useState<any>([]);
  const [workCdList, setWorkCdList] = useState<any>([]);
  const [taskCdList, setTaskCdList] = useState<any>([]);
  const [manpowerOptions, setManpowerOptions] = useState<any>([]);
  const [companyList, setCompanyList] = useState<any>([]);
  const [isExtHistoryModalOpen, setIsExtHistoryModalOpen] = useState<boolean>(false);

  const controlQuestions = [
    'Tools and materials secured against falling?',
    'Machinery / Tools / Equipments are inspected and fit for use?',
    'Assigned members are competent / trained for the task to be performed?'
  ];
  type ControlItem = {
    control?: 'Y' | 'N' | 'NA';
    controlRemark: string;
  };

  const [controlList, setControlList] = useState<ControlItem[]>(
    controlQuestions.map((_, index) => ({
      seq: index,
      control: undefined,
      controlRemark: ''
    }))
  );

  useEffect(() => {
    codeApi.getDiscpCodeList().then((list) => {
      setDisciplineCdList(list);
    });
    codeApi.getManpowerCodeList(props.formCode).then((list) => {
      setManpowerOptions(list);
    });
    companyUtil.getOptions().then((list) => {
      setCompanyList(list);
    });
  }, []);
  useEffect(() => {
    if (!props.data?.disciplineCd) {
      setWorkCdList([]);
      setTaskCdList([]);
      return;
    }

    setWorkCdList([]);
    setTaskCdList([]);

    codeApi.getDiscpCodeList(props.data.disciplineCd).then(setWorkCdList);
  }, [props.data?.disciplineCd]);

  useEffect(() => {
    if (!props.data?.workCd) {
      setTaskCdList([]);
      return;
    }

    setTaskCdList([]);

    codeApi.getDiscpCodeList(props.data.workCd).then(setTaskCdList);
  }, [props.data?.workCd]);

  useEffect(() => {
    if (!props.data) {
      props.setData((prev: any) => ({
        ...prev,
        workRisk: 'HIGH'
      }));
    }
  }, [props.data]);

  useEffect(() => {
    if (!props.data?.approvalMVOList || props.data?.approvalMVOList.length == 0) {
      ptwApi.getEmptyApprovalData({ formCode: props.formCode }).then((r) => {
        if (r.isSuccess) {
          props.setData((prev: any) => ({
            ...prev,
            workRisk: 'HIGH',
            approvalMVOList: [...r.resultList]
          }));
        }
      });
    }
  }, [props.data?.approvalMVOList]);

  useEffect(() => {
    if (!props.data?.control) return;

    const parsed =
      typeof props.data.control === 'string' ? JSON.parse(props.data.control) : props.data.control;
    setControlList(
      controlQuestions.map((_, index) => ({
        seq: index,
        control: parsed[index]?.control,
        controlRemark: parsed[index]?.controlRemark
      }))
    );
  }, [props.data?.control]);

  const addManPower = () => {
    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = [...prevList, { manPower1: null, manPower2: 0 }].map((row, idx) => ({
        ...row,
        seq: idx + 1
      }));

      return { ...prev, manPower: next };
    });
  };

  const delManPower = (index: number) => {
    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = prevList
        .filter((_: any, i: number) => i !== index)
        .map((row: any, idx: number) => ({
          ...row,
          seq: idx + 1
        }));

      return { ...prev, manPower: next };
    });
  };

  const handleChangeManPower = (index: number, field: string, e: any) => {
    const value = e?.target ? e.target.value : e;

    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = prevList.map((row: any, i: number) => {
        if (i === index) {
          return { ...row, [field]: value, seq: i + 1 };
        }
        return { ...row, seq: i + 1 };
      });

      return { ...prev, manPower: next };
    });
  };

  const workLocationCallback = (location: any, locationText: any) => {
    props.handleChange({
      target: {
        name: 'location',
        value: location,
        type: 'json'
      }
    });
    props.handleChange({
      target: {
        name: 'locationText',
        value: locationText
      }
    });
    setIsWorkLocationModalOpen(false);
  };

  const jhaCallback = (data: any) => {
    const changes = [
      { name: 'settingJhaSeq', value: data.settingJhaSeq },
      { name: 'jhaNo', value: data.jhaNo }
    ];

    changes.forEach(({ name, value }) => {
      props.handleChange({ target: { name, value } });
    });

    setJhaSearchModalOpen(false);
  };

  const statementNoCallback = (data: any) => {
    props.handleChange({ target: { name: 'statementNo', value: data.settingJhaSeq } });
    props.handleChange({ target: { name: 'statementJhaNo', value: data.jhaNo } });
    setStatementSearchModalOpen(false);
  };

  const sPcmCallback = (data: any) => {
    props.handleChange({ target: { name: 'sPcm', value: data.settingJhaSeq } });
    props.handleChange({ target: { name: 'sPcmJhaNo', value: data.jhaNo } });
    setSpCmSearchModalOpen(false);
  };

  const handleChangeControl = (
    index: number,
    field: 'control' | 'controlRemark',
    value: string
  ) => {
    const next = controlList.map((item, i) => (i === index ? { ...item, [field]: value } : item));

    setControlList(next);

    if (props.handleChange) {
      props.handleChange({
        target: {
          name: 'control',
          value: JSON.stringify(next)
        }
      });
    }
  };

  const deviceRegisterModalCallback = (checkedMap: Record<string, any[]>) => {
    if (!checkedMap) return;

    if (props.data.iotDeviceList === undefined) {
      props.data.iotDeviceList = {};
    }

    Object.entries(checkedMap).forEach(([key, data]) => {
      const existing = props.data.iotDeviceList[key] || [];
      const merged = [
        ...existing,
        ...data.filter(
          (newItem: any) => !existing.some((exItem: any) => exItem.deviceId === newItem.deviceId)
        )
      ];
      props.data.iotDeviceList[key] = merged;

      if (key === 'cctv') setCctvList(merged);
      else if (key === 'gasDetector') setGasDetactorList(merged);
      else if (key === 'smartHook') setSmartHookList(merged);
    });
  };

  const openDeviceRegisterModal = (gubun: string) => {
    setGubun(gubun);
    setIsDeviceRegisterModalOpen(true);
  };

  const [cctvList, setCctvList] = useState<any[]>([]);
  const [gasDetectorList, setGasDetactorList] = useState<any[]>([]);
  const [smartHookList, setSmartHookList] = useState<any[]>([]);

  useEffect(() => {
    if (!props.data?.iotDeviceList) return;
    setCctvList(props.data.iotDeviceList.cctv ?? []);
    setGasDetactorList(props.data.iotDeviceList.gasDetector ?? []);
    setSmartHookList(props.data.iotDeviceList.smartHook ?? []);
  }, [props.data?.iotDeviceList]);

  const deleteCctvItem = (item: any) => {
    const updated = cctvList.filter((i) => i.deviceId !== item.deviceId);
    setCctvList(updated);
    props.data.iotDeviceList.cctv = updated;
  };

  const deleteGasDetectorItem = (item: any) => {
    const updated = gasDetectorList.filter((i) => i.deviceId !== item.deviceId);
    setGasDetactorList(updated);
    props.data.iotDeviceList.gasDetector = updated;
  };

  const deleteSmartHookItem = (item: any) => {
    const updated = smartHookList.filter((i) => i.deviceId !== item.deviceId);
    setSmartHookList(updated);
    props.data.iotDeviceList.smartHook = updated;
  };

  return (
    <>
      <WorkLocationModal
        setIsModalOpen={setIsWorkLocationModalOpen}
        isModalOpen={isWorkLocationModalOpen}
        onActionCallback={workLocationCallback}
        location={props.data?.location}
        locationText={props.data?.locationText}
      />
      <JhaSearchModal
        setIsModalOpen={setJhaSearchModalOpen}
        isModalOpen={isJhaSeaerchModalOpen}
        title={'Add JHA'}
        columnHeaderLabel={'TRA No'}
        categorySeq={1}
        onActionCallback={jhaCallback}
      />
      <JhaSearchModal
        setIsModalOpen={setStatementSearchModalOpen}
        isModalOpen={isStatementSearchModalOpen}
        title={'Add Job Method Statement'}
        columnHeaderLabel={'MS No'}
        categorySeq={2}
        onActionCallback={statementNoCallback}
      />
      <JhaSearchModal
        setIsModalOpen={setSpCmSearchModalOpen}
        isModalOpen={isSpCmSearchModalOpen}
        title={'Add S-PCM'}
        columnHeaderLabel={'S-PCM No'}
        categorySeq={3}
        onActionCallback={sPcmCallback}
      />
      <DeviceRegisterModal
        setIsModalOpen={setIsDeviceRegisterModalOpen}
        isModalOpen={isDeviceRegisterModalOpen}
        onActionCallback={deviceRegisterModalCallback}
        gubun={gubun}
        targetPtwDSeq={props.data?.ptwDSeq}
        iotDeviceList={props.data?.iotDeviceList}
      />
      <div className={'cold-detail'}>
        {props.data?.approvalStatus === 'CANCEL' && (
          <div className="cancel-area">
            <img src={DashIcon} alt="ban icon" className="cancel-icon" />
            <div className="cancel-content-area">
              <div className="cancel-title">
                <span className="cancel-title-text">Permit Cancelled</span>
              </div>
              <div className="cancel-content">
                <div className="cancel-content-detail">
                  <span className="cancel-content-name">{props.data?.cancellerNm}</span>
                  <span>·</span>
                  <span className="cancel-content-comment">{props.data?.cancelComment}</span>
                </div>
                <div className="cancel-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.data?.cancelDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.data?.extendDate && (
          <div className="extend-area">
            <ExtensionHistoryModal
              isModalOpen={isExtHistoryModalOpen}
              setIsModalOpen={setIsExtHistoryModalOpen}
              ptwDSeq={props.data?.ptwDSeq}
            />
            <img src={ClockIcon} alt="ban icon" className="extend-icon" />
            <div className="extend-content-area">
              <div className="extend-title">
                <span className="extend-title-text">Extension Approved</span>
                <button
                  className="extend-history-btn"
                  onClick={() => setIsExtHistoryModalOpen(true)}
                >
                  EXTENSION HISTORY
                </button>
              </div>
              <div className="extend-content">
                <div className="extend-content-detail">
                  <span className="extend-content-name">{props.data?.extenderNm}</span>
                  <span>·</span>
                  <span className="extend-content-comment">{props.data?.comment}</span>
                </div>
                <div className="extend-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.data?.extendDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="contents-watermark-wrapper">
          <div
            className={
              'form-contents ' +
              (props.data?.approvalStatus === 'CANCEL' ? 'form-cancel-watermark' : '')
            }
          >
            {props.tbmNo && (
              <table className="form-table">
                <tbody>
                  <tr>
                    <th style={{ width: '300px' }}>TBM No</th>
                    <td>
                      <CustomText
                        onChange={props.handleChange}
                        name={'tbmNo'}
                        className={'form'}
                        readOnly={true}
                        value={props.tbmNo}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {/* renew로 생성시킨 데이터 */}
            {props.data?.refPtwDSeq && (
              <>
                <div className={'form-sub-title'}>Renewal Reference</div>
                <table className={'form-table'}>
                  <tbody>
                    <tr>
                      <th className={'form-required'} style={{ width: '300px' }}>
                        Renewed from Permit No
                      </th>
                      <td>
                        <CustomText
                          onChange={props.handleChange}
                          name={'refPtwNo'}
                          className={'form'}
                          readOnly={true}
                          value={props.data?.refPtwNo}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Renew Refrence File</th>
                      <td>
                        <CustomUploader
                          onChange={props.handleChange}
                          serverFiles={props.data?.newFileList}
                          readOnly={!props.data?.isNew}
                          stateGubun="new"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th className={'form-required'} style={{ width: '300px' }}>
                    Work Permit Number
                  </th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'ptwNo'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.ptwNo}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Task Risk Assessment No.</th>
                  <td>
                    <CustomText
                      name={'jhaNo'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.jhaNo}
                      isBtnSearch={!props.isReadOnly}
                      onSearchAction={() => {
                        setJhaSearchModalOpen(true);
                      }}
                      readOnly={true}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Method Statement No.</th>
                  <td>
                    <CustomText
                      name={'statementJhaNo'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.statementJhaNo}
                      isBtnSearch={!props.isReadOnly}
                      onSearchAction={() => {
                        setStatementSearchModalOpen(true);
                      }}
                      readOnly={true}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className={'form-sub-title'}>Work Requisition & Description</div>
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th className={'form-required'}>Job Description</th>
                  <td>
                    <CustomText
                      name={'description'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.description}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'} style={{ width: '300px' }}>
                    Work Risk
                  </th>
                  <td>
                    <CustomRadio
                      name={'workRisk'}
                      id={'workRisk'}
                      value={props.data?.workRisk ?? 'GENERAL'}
                      options={[
                        { label: 'General Work', value: 'GENERAL' },
                        { label: 'High-Risk Work', value: 'HIGH' }
                      ]}
                      onChange={props.handleChange}
                      disabled={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required form-required'}>Work Location / Area</th>
                  <td>
                    <div className={'group-td-column'}>
                      <CustomText
                        name={'locationText'}
                        className={'form'}
                        value={props.data?.locationText}
                        isBtnSearch={!props.isReadOnly}
                        onSearchAction={() => {
                          setIsWorkLocationModalOpen(true);
                        }}
                        readOnly={true}
                      />
                      <PermitIssueMap location={props.data?.location} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Company</th>
                  <td>
                    <CustomSelectSingle
                      name={'companyId'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.companyId}
                      options={companyList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Register</th>
                  <td>
                    <CustomText
                      name={'receiverNm'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.receiverNm}
                      defaultValue={props.userInfo.fullName}
                      onChange={props.handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Discipline</th>
                  <td>
                    <CustomSelectSingle
                      name={'disciplineCd'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.disciplineCd}
                      options={disciplineCdList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Detail 1</th>
                  <td>
                    <CustomSelectSingle
                      name={'workCd'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.workCd}
                      options={workCdList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Detail 2</th>
                  <td>
                    <CustomSelectSingle
                      name={'taskCd'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.taskCd}
                      options={taskCdList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Expected Work Duration</th>
                  <td>
                    <div className={'group-td-row'}>
                      <CustomDatetime
                        name={'validStartTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validStartTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getTodayMorning7()}
                        showTimeSelect={false}
                      />
                      <span>-</span>
                      <CustomDatetime
                        name={'validEndTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validEndTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getTodayAfternoon19()}
                        showTimeSelect={false}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingRight: '10px',
                        alignItems: 'center'
                      }}
                    >
                      <span className={'form-required'}>Manpower Planning</span>
                      <div>
                        {!props.isReadOnly && (
                          <div
                            className={'action-button'}
                            onClick={() => {
                              addManPower();
                            }}
                          >
                            <span style={{ fontSize: '20px' }}>+</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </th>
                  <td>
                    <div className={'group-td-column'}>
                      <div className={'custom-add'}>
                        <div className={'add-header'}>
                          <span className={'add-total'} style={{ width: '150px' }}>
                            Total
                          </span>
                          <span className={'add-cnt'} style={{ width: '100px' }}>
                            {props.data?.manPower?.reduce(
                              (acc: any, curr: any) =>
                                acc + (curr.manPower2 === '' ? 0 : +curr.manPower2),
                              0
                            ) ?? 0}
                          </span>
                        </div>
                        <div className={'add-list'}>
                          {props.data?.manPower?.map((item: any, index: number) => (
                            <div className={'add-item'} key={index}>
                              <div style={{ width: '150px' }}>
                                <CustomSelectSingle
                                  name={'manPower1'}
                                  className={'form'}
                                  onChange={(e) => handleChangeManPower(index, 'manPower1', e)}
                                  value={props.data?.manPower[index]?.manPower1}
                                  options={manpowerOptions}
                                  readOnly={props.isReadOnly}
                                />
                              </div>
                              <div style={{ width: '100px' }}>
                                <CustomNumber
                                  name={'manPower2'}
                                  className={'form'}
                                  onChange={(e) => handleChangeManPower(index, 'manPower2', e)}
                                  value={props.data?.manPower[index]?.manPower2}
                                  readOnly={props.isReadOnly}
                                />
                              </div>
                              {!props.isReadOnly && (
                                <div
                                  className={'action-button'}
                                  onClick={() => {
                                    delManPower(index);
                                  }}
                                >
                                  <span style={{ fontSize: '20px' }}>-</span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <PermitIssueForm
              formCode={props.formCode}
              handleChange={props.handleChange}
              data={props.data}
              isReadOnly={props.isReadOnly}
            />
            <div className={'form-sub-title'}>APPROVAL/CONFIRMATION</div>
            <FormApproval
              data={props.data}
              setData={props.setData}
              handleChange={props.handleChange}
              formCode={props.formCode}
              isReadOnly={props.isReadOnly}
              isFinish={props.isFinish}
            />
            <div className={'form-sub-title'}>Special Instruction</div>
            <div style={{ width: '100%' }}>
              <CustomTextarea
                name={'specialInstruction'}
                className={'form'}
                onChange={props.handleChange}
                value={props.data?.specialInstruction}
                placeholder={'* Please note in this column if the activity cancel'}
                isReload={true}
                disabled={props.isReadOnly}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form03SpaceDetail;
